import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  attachmentId?: number;
  iconOnly?: boolean;
  updateFiles: () => Promise<void>;
}

const CalendarEventAttachmentsRemove = ({
  attachmentId,
  iconOnly = false,
  updateFiles
}: Props) => {
  const {
    messages,
    pageState: { calendarEvent },
    theme
  } = useReduxState();

  const handleConfirm = async () => {
    try {
      await api.delete(
        `/admin/calendar-events/${calendarEvent.id}/attachments${
          attachmentId ? `/${attachmentId}` : ''
        }`
      );
      await updateFiles();
      return true;
    } catch (err) {
      return false;
    }
  };

  const buttonText = attachmentId
    ? messages.eventCalendarAttachmentRemove
    : messages.eventCalendarAttachmentRemoveAll;

  const confirmText = attachmentId
    ? messages.eventCalendarAttachmentRemoveMessage
    : messages.eventCalendarAttachmentRemoveAllMessage;

  const successMessage = attachmentId
    ? messages.eventCalendarAttachmentRemoveSuccess
    : messages.eventCalendarAttachmentRemoveAllSuccess;

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonCategory="lighter"
      buttonIcon="trash-alt"
      category="danger"
      confirmText={confirmText}
      confirmTitle={buttonText}
      onConfirm={handleConfirm}
      successMessage={successMessage}
      {...(iconOnly
        ? {
            buttonSize: 'small',
            buttonTooltip: buttonText
          }
        : { buttonText })}
    />
  );
};

export default CalendarEventAttachmentsRemove;
